import axios from "@/axios";
import { AxiosResponse } from "axios";
import {
  AddUserBody,
  UpdateUserBody,
  UserResponse,
  UsersResponse,
  PublishersResponse,
} from "@/features/setting/types";

export function getUsers(): Promise<AxiosResponse<UsersResponse>> {
  return axios.get<UsersResponse>(`/users/`);
}

export function getUser(userId: number): Promise<AxiosResponse<UserResponse>> {
  return axios.get<UserResponse>(`/users/${userId}/`);
}

export function getAgenciesPublishers(
  agencyId: number
): Promise<AxiosResponse<PublishersResponse>> {
  return axios.get<PublishersResponse>(`/agencies/${agencyId}/publishers/`);
}

export function getClientsPublishers(clientId: number): Promise<AxiosResponse<PublishersResponse>> {
  return axios.get<PublishersResponse>(`/clients/${clientId}/publishers/`);
}

export function addUser(data: AddUserBody): Promise<AxiosResponse<void>> {
  return axios.post(`/users/`, data);
}

export function updateUser(
  data: UpdateUserBody,
  userId: number | null
): Promise<AxiosResponse<void>> {
  return axios.put(`/users/${userId}/`, data);
}
